import { NgModule } from "@angular/core";
import { EvaluationPriceModalComponent } from "./evaluation-price-modal.component";
import { PriceModalFilterComponent } from "./price-modal-filter/price-modal-filter.component";
import { PriceGradientBarComponent } from "./price-gradient-bar/price-gradient-bar.component";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app-shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { FipeComparisonBadgeComponent } from '@app-components/fipe-comparison-badge/fipe-comparison-badge.component';

@NgModule({
  declarations: [
    EvaluationPriceModalComponent,
    PriceModalFilterComponent,
    PriceGradientBarComponent,
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatIconModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatSortModule,
    FipeComparisonBadgeComponent,
  ],
  exports: [EvaluationPriceModalComponent],
})
export class PriceModalModule {}
